import React, { useCallback, useState, useEffect, useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { VideocamOff } from "@mui/icons-material";
import * as poseDetection from "@tensorflow-models/pose-detection";
import * as handpose from "@tensorflow-models/handpose";
import * as fp from "fingerpose";
import { Hands } from "@mediapipe/hands";
// import { FingerPose } from "./fingerposeData"; // Import fingerpose gestures data
import * as tf from "@tensorflow/tfjs-core";
import "@tensorflow/tfjs-backend-webgl";
import { drawLines, gestureDifferences, getToleratedTimeframes, getReminders } from "../utils/PoseUitils";
// import { formatTime } from "../utils/CommonUtils";
import YouTube from "react-youtube";
import "./pose-detector-component.css";
// import { ScoreComponent } from "../components/score-component";
import { downloadCorrectGestureFile } from "../services/backend";
// import { Helmet } from "react-helmet";
import { HashLoader } from "react-spinners";

import { loggingApi } from "../services/backend";
import { AppSingleton } from "../services/user_config";

// import Particles, { initParticlesEngine } from "@tsparticles/react";
// // import { loadAll } from "@/tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
// // import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
// import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
// // import { loadBasic } from "@tsparticles/basic"; // if you are going to use `loadBasic`, install the "@tsparticles/basic" package too.

const gestureScalingFactor = 0.3; // 0.3
const isHandGestureDetection = false;
const isStopEngine = false;

const startHandGestureDetection = ({ videoRef, canvasRef, gestureStatusRef }) => {
  let isMounted = true;
  const runHandPoseDetection = async () => {
    const handposeModel = await handpose.load();
    const GE = new fp.GestureEstimator([fp.Gestures.VictoryGesture, fp.Gestures.ThumbsUpGesture]);
    const detectLeftHandPoses = async () => {
      // const desiredHand = "left";
      if (isMounted) {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        const predictions = await handposeModel.estimateHands(video);
        predictions.forEach((prediction) => {
          const landmarks = prediction.landmarks;

          const estimatedGestures = GE.estimate(landmarks, 8.5);
          // estimatedGestures.gestures.forEach((_gesture) => {
          //   console.log(_gesture.name);
          // });
          // console.log(estimatedGestures);
          [
            [0, 1],
            [1, 2],
            [2, 3],
            [3, 4],
            [0, 5],
            [5, 6],
            [6, 7],
            [7, 8],
            [5, 9],
            [9, 13],
            [13, 17],
            [9, 10],
            [10, 11],
            [11, 12],
            [13, 14],
            [14, 15],
            [15, 16],
            [17, 18],
            [18, 19],
            [19, 20],
          ].forEach((el) => {
            // console.log(`a: ${a}\tb: ${b}`);
            const a = el[0];
            const b = el[1];
            // drawLine({
            //   context,
            //   keypoint1: { x: landmarks[a][0], y: landmarks[a][1] },
            //   keypoint2: { x: landmarks[b][0], y: landmarks[b][1] },
            // });
            console.log(landmarks[a][0]);
            const handScalingFactor = 1.0;
            context.beginPath();
            context.moveTo(landmarks[a][0] * handScalingFactor, landmarks[a][1] * handScalingFactor);
            context.lineTo(landmarks[b][0] * handScalingFactor, landmarks[b][1] * handScalingFactor);
            context.lineWidth = 2;
            context.strokeStyle = "red";
            context.lineCap = "round";
            context.stroke();
          });
          // for (let i = 0; i < landmarks.length; i++) {
          //   const [x, y] = landmarks[i];
          //   context.beginPath();
          //   context.arc(x, y, 5, 0, 2 * Math.PI);
          //   context.fillStyle = "red";
          //   context.fill();
          // }
        });
        // Call detectHandPoses recursively
        requestAnimationFrame(detectLeftHandPoses);
      }
    };
    // Start detecting hand poses
    detectLeftHandPoses();
    // detectRightHandPoses();
  };
  runHandPoseDetection();
  // Clean up function
  return () => {
    isMounted = false;
  };
};

const resizeCanvasToVideo = ({ videoRef, canvasRef }) => {
  console.log("resizeCanvasToVideo");
  console.log(videoRef);
  console.log(canvasRef);
  if (videoRef && canvasRef) {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const aspectRatio = video.videoWidth / video.videoHeight;
    const factor = 0.4;
    const availableWidth = window.innerWidth * factor;
    const availableHeight = window.innerHeight * factor;
    let targetWidth, targetHeight;
    if (availableWidth / availableHeight > aspectRatio) {
      targetWidth = Math.floor(availableHeight * aspectRatio);
      targetHeight = availableHeight;
    } else {
      targetWidth = availableWidth;
      targetHeight = Math.floor(availableWidth / aspectRatio);
    }
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    console.log(`targetWidth: ${targetWidth}`);
    console.log(`targetHeight: ${targetHeight}`);
    console.log(`canvas width: ${canvas.width}`);
    console.log(`canvas height: ${canvas.height}`);
  }
};

const PoseDetectorComponent = ({ gestureStatusRef, scoreRef, tutorialVideoRef, isReadyRef, exerciseId }) => {
  const videoRef = useRef(null);
  const videoTimeStartSecondRef = useRef(-1);
  const canvasRef = useRef(null);
  const animationFrameRef = useRef(null);
  const [isCameraPermission, setCameraPermission] = useState(false);
  const [detector, setDetector] = useState(null);
  const [isTfReady, setIsTfReady] = useState(false);
  const [isCorrectGestureReady, setIsCorrectGestureReady] = useState(false);
  const correctGestureDictRef = useRef(null);
  // const scoreRef = useRef({});

  const startCamera = async () => {
    const appSingleton = new AppSingleton();
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        // video: true,
        video: {
          facingMode: "user",
          width: { ideal: 1280 }, // MARK: to prevent error of: Requested texture size [6304x6304] greater than WebGL maximum on this browser / GPU [4096x4096].
          height: { ideal: 720 }, // MARK: to prevent error of: Requested texture size [6304x6304] greater than WebGL maximum on this browser / GPU [4096x4096].
          frameRate: { ideal: appSingleton.mirrorFPS ?? 20 },
        },
      });
      setCameraPermission(true);
      // setNewText("await navigator.mediaDevices done");
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        // videoRef.current.style.transform = 'scaleX(-1)';  // MARK: use it if need to show camera, it work but comment it to save resources
        videoRef.current.play();
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };

  useEffect(() => {
    // public/video/fitness-3min-white10.json
    // downloadCorrectGestureFile({ filename: "fitness-3min-white10.json" })
    // downloadCorrectGestureFile({ filename: "01cd7ef2-df3f-4c23-b30f-e4d6efce22fd-white.json" })
    downloadCorrectGestureFile({ filename: `${exerciseId}.json` })
      .then((response) => {
        console.log("downloadCorrectGestureFile");
        console.log(response);
        correctGestureDictRef.current = response;
        setIsCorrectGestureReady(true);
      })
      .catch((error) => {
        loggingApi({ message: { error: error.message, from: "downloadCorrectGestureFile" } });
      });
  }, [exerciseId]);

  useEffect(() => {
    if (isTfReady && detector && isCorrectGestureReady) {
      isReadyRef.current = true;
      startCapture();
    }
  }, [isTfReady, detector, isCorrectGestureReady]);

  const startCapture = () => {
    console.log("startCapture");
    // startFingerGestureDetection({ videoRef, canvasRef });
    if (isHandGestureDetection) {
      startHandGestureDetection({ videoRef, canvasRef });
    }

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const video = videoRef.current;
    canvas.width = video.videoWidth * gestureScalingFactor;
    canvas.height = video.videoHeight * gestureScalingFactor;
    canvas.style.backgroundColor = "transparent";
    canvas.style.zIndex = 49;
    // resizeCanvasToVideo({ videoRef, canvasRef });
    // resizeCanvasToVideo

    const captureFrame = async () => {
      const tensor = tf.browser.fromPixels(video);
      const tensor_reversed = tensor;
      // const tensor_reversed = tf.reverse(tensor, 1);
      const poses = await detector.estimatePoses(tensor_reversed, {
        // flipHorizontal: true, // MARK: need to flip image for detection in production, e.g. iPad front camera
        decodingMethod: "single-person",
        maxPoseDetections: 1,
        scoreThreshold: 0.5,
        minPoseConfidence: 0.3,
      });
      // setTfMemoryInfo(tf.memory()); // MARK: this line will cuz other canvas keep re-renderingx
      tf.dispose(tensor);
      tf.dispose(tensor_reversed);
      context.clearRect(0, 0, canvas.width, canvas.height);
      if (poses.length > 0) {
        try {
          if (videoTimeStartSecondRef.current === -1) {
            videoTimeStartSecondRef.current = tutorialVideoRef.current.currentTime;
          }
          const videoCurrentTime = `${(tutorialVideoRef.current.currentTime - videoTimeStartSecondRef.current).toFixed(1)}`;
          // console.log(videoCurrentTime);
          // loggingApi({ message: `videoCurrentTime: ${videoCurrentTime}` });
          const correctGesture = correctGestureDictRef.current[videoCurrentTime];
          const correctGestures = getToleratedTimeframes({
            videoCurrentTime,
            tolerateSecond: 0.5,
            source: correctGestureDictRef.current,
          });
          let userGesture = {
            leftWrist: poses[0].keypoints[9],
            rightWrist: poses[0].keypoints[10],
            leftShoulder: poses[0].keypoints[5],
            rightShoulder: poses[0].keypoints[6],
            canvasSize: {
              width: videoRef.current.videoWidth,
              height: videoRef.current.videoHeight,
            },
          };
          const { reminders, status, leftWristDiff, rightWisttDiff, frameScore } = gestureDifferences({
            correctGesture,
            userGesture,
            correctGestures,
          });
          // console.log(`bingoNumber: ${bingoNumber}`);
          scoreRef.current = {
            ...scoreRef.current,
            [videoCurrentTime]: Math.max(scoreRef.current?.[videoCurrentTime] ?? 0, frameScore),
          };
          // console.log(`${videoCurrentTime}: ${scoreRef.current?.[videoCurrentTime]}`);
          // TODO: use dict to check is +score
          // const { leftMissing, leftLazy, rightMissing, rightLazy } = status;
          var { leftMissing, leftLazy, rightMissing, rightLazy } = gestureStatusRef.current;
          gestureStatusRef.current = {
            leftMissing: leftMissing * status.leftMissing + status.leftMissing,
            rightMissing: rightMissing * status.rightMissing + status.rightMissing,
            leftLazy: leftLazy * status.leftLazy + status.leftLazy,
            rightLazy: rightLazy * status.rightLazy + status.rightLazy,
          };
        } catch (error) {
          // loggingApi({ message: `error: ${serror.message}` });
          console.log(error);
        }
        const _poseKeyPointDict = drawLines({
          poses,
          context,
          factor: gestureScalingFactor,
        });
      }
      // poses.forEach((_pose) => {
      //   _pose?.dispose();
      // });
      if (!isStopEngine) {
        animationFrameRef.current = requestAnimationFrame(captureFrame);
      }
    };

    // Start capturing frames
    try {
      // MARK: turn off pose detector
      console.log(`captureFrame`);
      captureFrame();
      // const animate = async () => {
      //   await captureFrame();
      // };
      // animationFrameRef.current = requestAnimationFrame(animate);
    } catch (error) {
      console.log(`captureFrame Error: ${error}`);
    }
  };

  const initializePoseDetector = async () => {
    await tf.setBackend("webgl"); // Set the backend to 'webgl' for better performance
    await tf.ready(); // Wait for TensorFlow.js to initialize the backend
    setIsTfReady(true);
    const detectorConfig = {
      modelType: poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
    };
    const _detector = await poseDetection.createDetector(poseDetection.SupportedModels.MoveNet, detectorConfig);
    setDetector(_detector);
    console.log("Detector init");
    // resizeCanvasToVideo({ videoRef, canvasRef });
  };

  const handleVideoEnd = () => {
    videoTimeStartSecondRef.current = -1;
  };

  useEffect(() => {
    const _video = tutorialVideoRef.current;
    _video.addEventListener("ended", handleVideoEnd);
    initializePoseDetector();
    startCamera();
    return () => {
      _video.removeEventListener("ended", handleVideoEnd);
    };
    //   // window.addEventListener("resize", resizeCanvasToVideo);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <video
        ref={videoRef}
        // width={640 * 0.4}
        // height={480 * 0.4}
        autoPlay={true}
        playsInline={true}
        muted={true}
        style={{ display: "none" }}
      />
      <canvas ref={canvasRef} style={{ transform: "scaleX(-1)" }} />
      <Box sx={{ position: "absolute" }}>
        {isCameraPermission ? null : (
          <IconButton>
            <VideocamOff />
          </IconButton>
        )}
        <HashLoader
          color="white"
          loading={!detector}
          cssOverride={{ display: "block", margin: "0 auto", borderColor: "red" }}
          size={48}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </Box>
    </Box>
  );
};

export { PoseDetectorComponent };
